const styles = theme => {
  return {
    root: { width: '550px', backgroundColor: '#FFFFFF' },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column'
    },
    row: { margin: '5px' },
    title: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    titleRow: { fontWeight: '700', fontSize: '16px', margin: '5px' },
    italicRow: {
      paddingLeft: '30px',
      fontStyle: 'italic',
      margin: '5px',
      display: 'inherit',
      flexDirection: 'row'
    },
    portingRow: {
      backgroundColor: 'lightblue',
      height: 'fit-content',
      margin: '5px 0',
      padding: '5px'
    },
    infoRow: {
      backgroundColor: '#FFE5CC',
      height: 'fit-content',
      margin: '5px 0',
      padding: '5px'
    },
    codeRow: { display: 'inherit', flexDirection: 'row' },
    boldRow: { fontWeight: '700', margin: '5px' },
    link: {
      '&:hover': { filter: 'brightness(1.5)' },
      cursor: 'pointer',
      margin: '0 2px'
    },
    container: { margin: '10px 0' },
    qrCodeContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '20px'
    },
    bold: { fontWeight: 600 },
    sampleIcon: { width: '80px' },
    icon: { width: '150px' },
    footer: {
      display: 'flex',
      justifyContent: 'center',
      padding: '10px 0',
      '& button': {
        marginRight: '10px',
        [theme.breakpoints.down('xs')]: {
          marginTop: '10px'
        }
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        alignItems: 'center'
      }
    }
  };
};

export default styles;
